import {
  AUTHORISED_DISTRIBUTORS,
  PARALLEL_IMPORTERS,
} from '@/constants/global';

import { DEALER_TYPE_ABBR_AD, DEALER_TYPE_ABBR_PI } from './constants';
import type { ConvertToDealerTypeAbbr, DealerTypeAbbr } from './types';

export const isDealerTypeAbbr = (value: unknown): value is DealerTypeAbbr => ( // @suppress longLineCheck
  typeof value === 'string' && [
    DEALER_TYPE_ABBR_AD,
    DEALER_TYPE_ABBR_PI,
  ].includes(value)
);

export const convertToDealerTypeAbbr: ConvertToDealerTypeAbbr = (
  dealerType,
) => {
  switch (dealerType) {
    case AUTHORISED_DISTRIBUTORS:
      return DEALER_TYPE_ABBR_AD;
    case PARALLEL_IMPORTERS:
      return DEALER_TYPE_ABBR_PI;
    default:
      throw new Error('Invalid dealer type');
  }
};
